import React, { useContext, useEffect, useState } from "react";
import RequestBuy from "../components/common/requestForm/RequestBuy";
import ContactWays from "../components/layout/ContactWays";
import { Helmet } from "react-helmet";
import { useRouteInfo } from "../hooks/useRouteInfo";
const ContactUsPage = (props) => {
  const { metaData } = useRouteInfo();

  return (
    <div className="py-12 container_1">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaData?.meta_title}</title>
        <meta name="description" content={metaData?.meta_desc} />
        <meta name="og:description" content={metaData?.meta_desc} />
        <meta name="og:title" content={metaData?.meta_title} />
        <link rel="canonical" href={metaData?.canonical} />
        <meta property="og:type" content={metaData?.meta_type} />
      </Helmet>{" "}
      <RequestBuy />
      <div className="py-12">
        <ContactWays data={props.dealerData} contact />
      </div>
      <div className="grid grid-cols-2 gap-7 mt-12">
        <span>
          <iframe
            title="location"
            className="rounded-[10px] w-full h-[350px] border-brand"
            src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3219.4323099585054!2d59.62227684503667!3d36.204685875022335!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzbCsDEyJzE3LjgiTiA1OcKwMzcnMjQuNiJF!5e0!3m2!1sen!2sus!4v1751460661468!5m2!1sen!2sus"
          />
        </span>
        <span className="flex justify-center items-center flex-col">
          <img
            src="/Location.png"
            className="w-[35px] mb-4"
            alt="Location_icon"
          />
          <p className="mb-4">
            مشهد ابتدای جاده قدیم نیشابور رباط طرق ساختمان ۱۹۲۴
          </p>
          <a
            href="https://www.google.com/maps/dir/?api=1&destination=36.20482579173691,59.62344577180925"
            target="_blank"
            rel="noreferrer"
            className="btn-brand w-[220px]"
          >
            مسیریابی
          </a>
        </span>
      </div>
    </div>
  );
};

export default ContactUsPage;
